import React from 'react';
import { ErrorBoundary, ErrorBoundaryName } from '../../../monitoring/error-boundary';
import { HStack, VStack, Box, IconButton, Text } from '@cad-arc';

export const EntityPanelTab = (props: {
    title: string;
    children: React.ReactNode;
    titleTrailingNode?: React.ReactNode;
    errorBoundaryName: ErrorBoundaryName;
    onClose: () => void;
    testId: string;
}) => {
    return (
        <ErrorBoundary name={props.errorBoundaryName}>
            <VStack h="100%" spacing={0} data-testid={props.testId}>
                <Box w="100%" py={3} px={3}>
                    <HStack
                        w="100%"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Text variant="headingMd" data-testid={`${props.testId}_TITLE`}>
                            {props.title}
                        </Text>
                        <HStack spacing={2}>
                            {props.titleTrailingNode}
                            <IconButton
                                icon="Close"
                                variant="ghost"
                                aria-label="close tab"
                                onClick={props.onClose}
                            />
                        </HStack>
                    </HStack>
                </Box>
                <Box w="100%" flexGrow={1000} overflowY="auto" px={3} pb={3}>
                    {props.children}
                </Box>
            </VStack>
        </ErrorBoundary>
    );
};
